import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { ArrowRight, Briefcase } from 'lucide-react'

const Explore = ({ data, categoryJobs, allJob, setFilteredData }) => {
    let [selectedDep, setSelectedDept] = useState('')

    return (
        <div className='bg-slate-50 py-16' >
            <div className='container mx-auto px-6 poppins' >
                <section className='flex items-end justify-between mb-10' >
                    <div>
                        <h4 className='text-3xl md:text-4xl font-bold text-slate-900 mb-2'>Explore by category</h4>
                        <p className='text-slate-600'>Find the perfect role across our specialized departments.</p>
                    </div>
                    <button 
                        onClick={() => {
                            setSelectedDept('');
                            setFilteredData(allJob);
                        }}
                        className='hidden md:flex text-blue-600 items-center gap-2 text-sm font-bold hover:text-blue-800 transition-colors' 
                    >
                        Show all jobs
                        <ArrowRight size={18} />
                    </button>
                </section>

                <section className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6' >
                    {categoryJobs && Object.entries(categoryJobs).map(([key, value], index) => {
                        const isSelected = selectedDep === key;
                        return (
                            <motion.article
                                key={key}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                viewport={{ once: true }}
                                onClick={() => {
                                    document.getElementById('jobsSection')?.scrollIntoView({ behavior: 'smooth' })
                                    if (selectedDep !== key) {
                                        setFilteredData(allJob.filter((obj2) => obj2.department_name === key));
                                        setSelectedDept(key)
                                    } else {
                                        setSelectedDept('')
                                        setFilteredData(allJob)
                                    }
                                }}
                                className={`
                                    relative overflow-hidden cursor-pointer rounded-2xl p-6 transition-all duration-300
                                    ${isSelected 
                                        ? 'bg-[#01014C] text-white shadow-xl shadow-blue-900/20 scale-[1.02]' 
                                        : 'bg-white text-slate-800 shadow-sm border border-slate-100 hover:shadow-lg hover:border-blue-100 hover:-translate-y-1'
                                    }
                                `} 
                            >
                                <div className={`mb-4 inline-flex p-3 rounded-xl ${isSelected ? 'bg-white/10 text-blue-300' : 'bg-blue-50 text-blue-600'}`}>
                                    <Briefcase size={28} strokeWidth={1.5} />
                                </div>
                                <h5 className='text-xl font-bold mb-4 line-clamp-1' title={key}>
                                    {key}
                                </h5>
                                <div className={`flex items-center justify-between text-sm ${isSelected ? 'text-blue-200' : 'text-slate-500'}`}>
                                    <p className='m-0 font-medium'>{value} job{value > 1 ? 's' : ''} available</p>
                                    <ArrowRight size={18} className={`transition-transform duration-300 ${isSelected ? 'translate-x-1 text-white' : 'group-hover:translate-x-1 text-blue-500'}`} />
                                </div>
                            </motion.article>
                        )
                    })}
                </section>
                
                <button 
                    onClick={() => {
                        setSelectedDept('');
                        setFilteredData(allJob);
                    }}
                    className='mt-8 md:hidden w-full text-center text-blue-600 flex justify-center items-center gap-2 text-sm font-bold' 
                >
                    Show all jobs
                    <ArrowRight size={18} />
                </button>
            </div>
        </div>
    )
}

export default Explore